<template>
  <span
    v-if="error"
    class="error__message"
  >
    {{ error[0] }}
  </span>
</template>

<script>
export default {
  name: 'InputErrorMessage',
  props:['error'],
};
</script>

<style scoped lang="scss">
.error__message {
  position: absolute;
  transform: translateY(5px);
  font-size: 10px;
  color: red;
}
</style>